import { Injectable } from '@angular/core';

@Injectable()
export class InitialsService {

  constructor() { }
  public fetch(firstName, lastName) {
    return firstName.charAt(0) + lastName.charAt(0);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src185846418/src/src/app/services/initials/initials.service.ts